export const formatNumberByThousands = (value: number) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

export const formatNumberWithDecimals = (value: number, decimals: number) => {
  const fixed = Number(value).toFixed(decimals);
  const unsigned = Number(fixed) === 0 ? fixed.replace("-", "") : fixed;
  const [integerPart, decimalPart] = unsigned.split(".");

  return `${integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ")}.${decimalPart}`;
};

export const formatNumberWithTwoDecimals = (value: number) =>
  formatNumberWithDecimals(value, 2);
